<template>
    <div :class="wrapperClass">
        <input
            type="checkbox"
            :id="id"
            :checked="modelValue"
            @change="$emit('update:modelValue', $event.target.checked)"
        >
        <label class="add-on form-check-label form-label-alt" :for="id">
            <span>{{ label }}<span v-if="required" class="required"> *</span></span>
            <FieldTooltip :content="tooltipHtml"/>
        </label>
    </div>
</template>

<script setup>
import {computed, toRef} from 'vue';
import FieldTooltip from './FieldTooltip.vue';
import {useFieldTooltip} from '../useFieldTooltip';

const props = defineProps({
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: '' },
    /** Field description key, @see FieldDescriptionService::GROUPS */
    tooltip: { type: String, default: '' },
    id: { type: String, required: true },
    required: { type: Boolean, default: false },
    recommended: { type: Boolean, default: false },
    noMargin: { type: Boolean, default: false },
});

defineEmits(['update:modelValue']);

const tooltipHtml = useFieldTooltip(toRef(props, 'tooltip'));

const wrapperClass = computed(() => ({
    'input checkbox': true,
    'form-highlight': props.required || props.recommended,
    'mb-3': !props.noMargin,
}));
</script>
